import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import LeadGeneratorThreadService from "./threadService";

const leadGeneratorThreadService = LeadGeneratorThreadService.initialize({
    apiService: salesApiService.aiAgent.leadGenerator,
    settings: salesSettingsHelper,
});

export default leadGeneratorThreadService;
